export const styles = {
    container: {
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f0f0f0', // Um cinza claro como cor de fundo
        minHeight: '100vh', // Garante que o container ocupe a altura total da tela
    },
    titulo: {
        color: '#333',
        textAlign: 'center',
        marginBottom: '20px',
    },
    descricao: {
        textAlign: 'center',
        marginBottom: '30px',
        color: '#666', // Um cinza escuro para o texto
    },
    botaoEditar: {
        display: 'block', // Centraliza o botão na página
        margin: '0 auto',
        padding: '10px 20px',
        backgroundColor: '#007bff', // Um azul como cor de fundo do botão
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '16px',
    },
    detalhesGrupo: {
        marginBottom: '15px',
    }
};
